import { ChangeDetectionStrategy, Component, OnDestroy, signal, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { NavigationService } from '../navigation.service';
import { LayoutService } from '../layout.service';
import { MemberStateService } from '../../services/member-state.service';
import { UserContextService } from '../../services/user-context.service';
import { NavGroup } from '../nav-model';

@Component({
  selector: 'myabvv-sidebar-nav',
  standalone: true,
  templateUrl: './sidebar-nav.component.html',
  styleUrl: './sidebar-nav.component.css',
  imports: [RouterLink, RouterLinkActive, TranslatePipe],
  // Hide the whole sidebar (no empty column) when there is nothing to show,
  // e.g. an internal user who has not selected a member yet.
  host: { '[style.display]': 'groups().length ? null : \'none\'' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarNavComponent implements OnDestroy {
  private navigation = inject(NavigationService);
  private memberState = inject(MemberStateService);
  layout = inject(LayoutService);
  private userContext = inject(UserContextService);

  readonly groups = signal<NavGroup[]>([]);
  private readonly memberSubscription: Subscription;

  // Public so the template can read the shared collapsed state (the toggle lives in the header).
  constructor() {
    // Recompute the visible groups whenever the selected member changes, so internal
    // staff only see the member search until they pick a member.
    this.memberSubscription = this.memberState.getMember().subscribe(member => {
      this.groups.set(this.navigation.getGroups(!!member));
    });
  }

  logout(): void {
    this.userContext.logout();
  }

  ngOnDestroy(): void {
    this.memberSubscription.unsubscribe();
  }
}
